// pl_pms_revenue.ts
// Tłumaczenia dla PMS.Revenue.tsx

export const plPmsRevenue = {

  title: "Revenue Management",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    forecast:          "Prognoza i spostrzeżenia",
    demandCalendar:    "Kalendarz popytu",
    activeRestrictions:"Aktywne ograniczenia",
    eventsImpact:      "Wpływ wydarzeń",
    conflictEngine:    "Silnik konfliktów",
    governance:        "Zarządzanie",
    derivedRules:      "Zasady pochodne",
    groupsBlocks:      "Grupy i blokady",
  },

  // ── Etykiety KPI / tabeli ─────────────────────────────────────────────────
  labels: {
    adrGap:           "Luka ADR",
    cancellationRate: "Wskaźnik anulowania",
    corporatePickup:  "Pickup korporacyjny",
    behindPace:       "W tyle",
    onPace:           "Na tempie",
    base:             "Bazowa",
    active:           "Aktywna",
    corporate:        "Korporacyjna",
    event:            "Wydarzenie",
    forecast:         "Prognoza",
    critical:         "Krytyczny",
  },

} as const;

export default plPmsRevenue;
